import {DateRangeActiveRecord} from './active_record/base'
import {date} from '@eitje/utils'

class SickPeriod extends DateRangeActiveRecord {
	static defaultJoins = ['users']
	static startDateField = 'start'
	static endDateField = 'end'
	static tableName = 'sickPeriods'
	static sort = {field: 'start', direction: 'desc'}

	startDate() {
		return date(this.start)
	}

	endDate() {
		return this.end && date(this.end)
	}

	_endDate = () => {
		const end = this[this.constructor.endDateField]
		return end ? date(end).endOf('day') : end
	}

	formatPeriod() {
		const formattedStart = this.startDate().ftime('dayMonth')
		const end = this.endDate()
		const formattedEnd = end?.ftime('dayMonth') || '...'
		return `${formattedStart} - ${formattedEnd}`
	}

	totalDays() {
		return this.end && super.totalDays() + 1 // +1 because endDate is inclusive
	}

	isOnDate(date) {
		return this.dateRange.contains(date)
	}

	reset() {
		return this.resourceReq('reset')
	}
}

export default SickPeriod
